import { convertAttributesInElement } from '@storyblok/react'
import {
  type StoryblokRichTextNode,
  useStoryblokServerRichText,
} from '@storyblok/react/rsc'
import { type ReactElement } from 'react'

import { type StoryblokRichtext } from './storyblok'

/**
 * A helper hook to cover the Storyblok TypeScript issue mentioned in https://www.storyblok.com/docs/packages/storyblok-react#usestoryblokrichtext.
 *
 * > We have identified issues with richtext and Types on React 19 and Next.js 15. As a temporary measure, we advise you to continue using React 18 and Next.js 14 until we have fully resolved the issues.
 *
 * Usage of `StoryblokRichText` is not recommended. The component wraps the content in a non-customizable `<div />` element breaking `.prose` functionality.
 */
export const useCmsRichTextRender = () => {
  const { render } = useStoryblokServerRichText({})

  return (
    content: StoryblokRichtext,
  ): ReturnType<typeof convertAttributesInElement> =>
    convertAttributesInElement(
      render(content as StoryblokRichTextNode) as ReactElement,
    )
}
